import { Box, Button, Modal, Stack, TextField, styled, Typography, Paper } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAdminContext } from '../../global/AdminContext';
import { API_URL } from '../../global/constants';
import { CircularStatic } from '../CircularProgressWithLabel';
import { InterviewInstructions } from '../InterviewInstructions';
import { Header } from '../shared/Header';
import styles from './login.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setInterviewDetails } from '../../features/interview/interview';
import { PROCTORING_TOOL } from '../../global/constants';
const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '70%',
	height: '80%',
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};

const termsModalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: { xs: '90%', sm: '70%', md: '70%' },
	maxHeight: { xs: '95%', sm: '80%', md: '80%' },
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 3,
	display: 'flex',
	flexDirection: 'column',
};

export const Login = () => {
	const { state } = useLocation();
	const dispatch = useDispatch();
	const params = useParams();
	const navigate = useNavigate();
	const { admin, setAdmin } = useAdminContext();
	const [loginType, setLoginType] = useState(state?.type || params?.type || null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [candidateCode, setCandidateCode] = useState();
	const [isLoading, setisLoading] = useState(false);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [isOpenInstructionsModal, setIsOpenInstructionsModal] = useState(false);
	const [isOpenTermsModal, setIsOpenTermsModal] = useState(false);

	useEffect(() => {
		if (admin.loading) return;
		if (admin.exists) {
			navigate('/login/company');
		}
	}, [admin, navigate]);

	const switchLoginType = (value) => {
		setLoginType(value);
	};

	const handleCompanyLogin = async () => {
		try {
			setErrorMessage('');
			setisLoading(true);
			if (!email) setErrorMessage('email cannot be empty');
			if (!password) setErrorMessage('password cannot be empty');
			const result = await axios.post(`${API_URL}/labs/login`, {
				email,
				password,
			});
			setisLoading(false);
			setAdmin({
				...result.data,
				loading: false,
				exists: true,
			});
			console.log(result.data, 'result.data');
			sessionStorage.setItem('admin', JSON.stringify(result.data));
			const roles = JSON.parse(sessionStorage.getItem('admin')).roles || [];
			console.log(roles, 'Roles');
			for (let role of roles) {
				if (role === 'college') {
					navigate('/college-admin');
					return;
				}
			}

			navigate('/dashboard/jobslist/company');
		} catch (error) {
			console.log(error);
			setErrorMessage(error.response.data.error);
			setisLoading(false);
		}
	};

	const generateCandidateDetails = async () => {
		setisLoading(true);
		const result = await axios.get(`${API_URL}/labs/interview/${candidateCode}`);
		console.log(result.data.error, 'Result.data.error');

		if (result?.data?.error) {
			setErrorMessage(result?.data?.message);
			setisLoading(false);
			return;
		}
		const { candidate_interview, fullName } = result.data;
		const { _id, proctoring_tool, job_id } = candidate_interview;
		if (proctoring_tool === PROCTORING_TOOL) {
			const jwtpayload = {
				candidateName: fullName,
				candidateId: _id,
				userType: 'candidate',
				organisationId: '78d87160-8408-472b-be40-e342daf666a3',
				sourceEventId: 'AIHYR Interview',
				eventName: 'AIHYR Interview',
				callBackURL: `${API_URL}/proctoring/details`,
				examDurationInMins: 45,
				iat: parseInt(Date.now() / 1000),
				exp: parseInt(Date.now() / 1000 + 12 * 60 * 60),
			};

			const response = await axios.post(`${API_URL}/proctoring/token`, jwtpayload);
			const interview_data = {
				candidate_interview,
				fullName,
				proctoring_token: response.data.token,
			};

			dispatch(setInterviewDetails(interview_data));
			return interview_data;
		} else {
			const interview_data = {
				candidate_interview,
				fullName,
			};

			dispatch(setInterviewDetails(interview_data));
			return interview_data;
		}
	};

	const startInterview = async () => {
		setIsOpenTermsModal(true);
	};

	const proceedWithInterview = async () => {
		const interview_data = await generateCandidateDetails();
		if (!interview_data) return;
		const { fullName, isDemo, isStudentInterview, candidate_interview, proctoring_token } =
			interview_data;
		const {
			proctoring_tool,
			is_coding_test_included,
			_id: interview_key,
		} = candidate_interview;

		axios.post(`${API_URL}/labs/interview/consent`, {
			interviewKey: interview_key,
			consent: true,
		});

		if (proctoring_tool === PROCTORING_TOOL) {
			if (is_coding_test_included) {
				navigate(`/coding-test/${fullName}/${interview_key}`);
			} else {
				navigate(`/interview`);
			}
		} else {
			navigate(`/check/${fullName}/${interview_key}`);
		}
	};

	const handleTermsAccept = () => {
		setIsOpenTermsModal(false);
		proceedWithInterview();
	};

	const handleTermsDecline = () => {
		setIsOpenTermsModal(false);
	};

	const updateCandidateCode = (e) => {
		setCandidateCode(e?.target?.value.trim());
	};

	const openInstructionsModal = () => {
		setIsOpenInstructionsModal(true);
	};

	const handleInstructionsModalClose = () => {
		setIsOpenInstructionsModal(false);
	};
	// const styles = theme => ({
	//   notchedOutline: {
	//     borderWidth: "1px",
	//     borderColor: "yellow !important"
	//   }
	// });
	const CustomTextField = styled(TextField)({
		'& label.Mui-focused': {
			color: '#224C84',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: '#B2BAC2',
		},
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: '#E0E3E7',
			},
			'&:hover fieldset': {
				borderColor: '#B2BAC2',
			},
			'&.Mui-focused fieldset': {
				borderColor: '#224C84',
			},
		},
	});
	return (
		<>
			<Header />
			<Stack direction="column">
				<div className={styles.loginPageContainer}>
					{!isLoading && (
						<>
							<Link to="/interview/practice/" color="#224C84">
								Take a Practice Interview
							</Link>
							<div>Or</div>
						</>
					)}
					{!isLoading && (
						<div className={styles.loginContainer}>
							{loginType === 'company' && (
								<div>
									<h4>Enter Admin Email and Password</h4>
									<TextField
										sx={{ width: '100%', marginBottom: '20px' }}
										id="outlined-basic"
										label="Enter Email"
										type="email"
										className="input-box"
										variant="outlined"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										error={!!errorMessage}
										helperText={errorMessage}
									/>
									<TextField
										sx={{ width: '100%', marginBottom: '20px' }}
										id="outlined-basic2"
										label="Enter Password"
										type="password"
										variant="outlined"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										error={!!errorMessage}
										helperText={errorMessage}
									/>
									<Button
										sx={{
											marginBottom: '20px',
											textTransform: 'none',
											width: '100%',
											backgroundColor: '#224C84',
											'&:hover': { backgroundColor: '#224C84' },
										}}
										variant="contained"
										onClick={handleCompanyLogin}
									>
										Login
									</Button>
									<div
										onClick={() => switchLoginType('candidate')}
										onKeyDown={() => switchLoginType('candidate')}
									>
										<h4 className={styles.switchLoginLink}>
											Are you a candidate? Go to Candidate login
										</h4>
									</div>
								</div>
							)}
							{loginType === 'college' && (
								<div>
									<h4>Enter college Email and Password</h4>
									<TextField
										sx={{ width: '100%', marginBottom: '20px' }}
										id="outlined-basic"
										label="Enter college Email"
										type="email"
										className="input-box"
										variant="outlined"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										error={!!errorMessage}
										helperText={errorMessage}
									/>
									<TextField
										sx={{ width: '100%', marginBottom: '20px' }}
										id="outlined-basic2"
										label="Enter Password"
										type="password"
										variant="outlined"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										error={!!errorMessage}
										helperText={errorMessage}
									/>
									<Button
										sx={{
											marginBottom: '20px',
											textTransform: 'none',
											width: '100%',
											backgroundColor: '#224C84',
											'&:hover': { backgroundColor: '#224C84' },
										}}
										variant="contained"
										onClick={() => navigate('/college-admin')}
									>
										Login
									</Button>
									{/* <div
                    onClick={() => switchLoginType("candidate")}
                    onKeyDown={() => switchLoginType("candidate")}
                  >
                    <h4 className={styles.switchLoginLink}>
                      Are you a candidate? Go to Candidate login
                    </h4>
                  </div> */}
								</div>
							)}
							{loginType === 'candidate' && !isLoading && (
								<div>
									<h4>
										Please read the{' '}
										<span
											style={{
												color: '#224C84',
												textDecoration: 'underline',
												cursor: 'pointer',
											}}
											onClick={openInstructionsModal}
											onKeyDown={openInstructionsModal}
										>
											Interview Instructions
										</span>{' '}
										carefully before proceeding.
									</h4>
									<h4>Enter Interview Key to start Interview</h4>

									<TextField
										sx={{ width: '100%', marginBottom: '20px' }}
										// id="outlined-basic"
										label="Enter Interview Key"
										variant="outlined"
										onChange={(e) => setCandidateCode(e?.target?.value.trim())}
										error={!!errorMessage}
										helperText={errorMessage}
									/>
									<Button
										sx={{
											marginBottom: '20px',
											textTransform: 'none',
											width: '100%',
											backgroundColor: '#224C84',
											'&:hover': { backgroundColor: '#224C84' },
										}}
										variant="contained"
										onClick={startInterview}
									>
										Start Interview
									</Button>
									<div
										onClick={() => switchLoginType('company')}
										onKeyDown={() => switchLoginType('company')}
									>
										<h4 className={styles.switchLoginLink}>
											Not a candidate? Go to company login
										</h4>
									</div>
								</div>
							)}
						</div>
					)}
					{isLoading && (
						<div>
							<CircularStatic />
						</div>
					)}
					{isOpenInstructionsModal && (
						<Modal
							open={isOpenInstructionsModal}
							onClose={handleInstructionsModalClose}
							aria-labelledby="instructions-modal-title"
							aria-describedby="instructions-modal-description"
						>
							<Box sx={modalStyle}>
								<InterviewInstructions />
							</Box>
						</Modal>
					)}
					{isOpenTermsModal && (
						<Modal
							open={isOpenTermsModal}
							onClose={handleTermsDecline}
							aria-labelledby="terms-modal-title"
							aria-describedby="terms-modal-description"
						>
							<Box sx={termsModalStyle}>
								<Typography variant="h5" component="h5" id="terms-modal-title">
									Proctoring T&C
								</Typography>
								<br />
								<Paper
									variant="outlined"
									component="div"
									sx={{
										flexGrow: 1,
										overflowY: 'auto',
										// ensure inner scroll on really small screens
										maxHeight: {
											xs: 'calc(100% - 160px)',
											sm: 'calc(100% - 140px)',
										},
										mb: 2,
										p: 2,
									}}
								>
									<Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
										Candidate Rules Agreement:
									</Typography>
									<ol>
										<li>
											I will not access the following types of personal items
											during the interview: hand-held devices or other
											electronic devices including cell phones, pagers, smart
											watches, wallets, hats (and other head coverings), bags,
											books and notes or any other materials not specifically
											approved.
										</li>
										<li>
											I will not receive any assistance from other individuals
											in the process of interview and will not allow the
											computer/laptop/tab screen presenting the interview
											questions to be seen by other individuals.
										</li>
										<li>
											I will ensure that there will be no one else present in
											the room during the interview process and ensure there
											are no background noises during the interview.
										</li>
										<li>
											I understand that eating, smoking, and chewing gum are
											prohibited during the interview.
										</li>
										<li>
											That during the interview process, I hereby give my
											consent that the proctor will monitor my activity
											through video and audio continuously including record
											audio and video of my face, voice, and physical room
											where I am seated during the interview. If I do not wish
											to be recorded (either by video or audio), I will notify
											the Company representative immediately of my intent not
											to proceed with the interview.
										</li>
										<li>
											If I experience problems that affect my ability to give
											the interview, I will notify the same immediately to the
											Company representative.
										</li>
										<li>
											The proctor or the remote proctoring tool cannot answer
											questions related to interview contents. If I have
											questions of this nature, I will contact the Company
											representative after completing interview process.
										</li>
										<li>
											I understand that breaks are not allowed during the
											interview for any reason. If I take a break, I
											understand and agree that I will not be allowed to
											resume the interview at a later time, my candidature for
											the interview shall be treated as invalid.
										</li>

										<li>
											Any inappropriate or wrongful conduct, as determined in
											Remote proctoring tool or the proctor's sole discretion,
											witnessed while monitoring my current location, will be
											reported to the Company representative.
										</li>
										<li>
											The taking of screenshot, photograph of the test screen
											is strictly banned. Violation of the same shall lead to
											the expulsion from the future interview.
										</li>
										<li>
											I have gone through the all the instructions for the
											process of interview and I shall abide by the same in
											its true letter and spirit.
										</li>
									</ol>
									<Typography
										variant="subtitle1"
										sx={{ fontWeight: 'bold', mt: 2 }}
									>
										Candidate Statement: By clicking the Accept button, I hereby
										give my consent that I have read all the terms and
										conditions mentioned herein above and agree that the Company
										representative may retain my personal data including, video
										or audio recording, photographs, snapshots and responses
										captured during the interview process and responses on the
										interview responses.
									</Typography>
								</Paper>
								<Stack
									direction="row"
									spacing={2}
									justifyContent="flex-end"
									sx={{ mt: 2 }}
								>
									<Button
										variant="outlined"
										color="error"
										onClick={handleTermsDecline}
									>
										Decline
									</Button>
									<Button
										variant="contained"
										color="primary"
										onClick={handleTermsAccept}
										sx={{
											backgroundColor: '#224C84',
											'&:hover': { backgroundColor: '#224C84' },
										}}
									>
										Accept
									</Button>
								</Stack>
							</Box>
						</Modal>
					)}
				</div>
			</Stack>
		</>
	);
};
